function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

const modifyBackground = debounce(function(navbarArg) {
  const logoWhite = document.querySelector(".navbar-logo");
  const logoBlack = document.querySelector(".navbar-logo-black");

  if (window.scrollY >= navbarArg.scrollHeight) {
    navbarArg.classList.add("white");
    logoWhite.classList.add("d-none");
    logoBlack.classList.remove("d-none");
  } else {
    navbarArg.classList.remove("white");
    logoWhite.classList.remove("d-none");
    logoBlack.classList.add("d-none");
  }
}, 15);

const initUpdateNavbarOnScroll = () => {
  const navbar = document.querySelector('.navbar-website');
  if (navbar) {
    window.addEventListener('scroll', modifyBackground.bind(this, navbar));
  }
}

const initPreventScrollOnNavbar = () => {
  const checkBox = document.querySelector(".navbar-right-mobile input");
  const body = document.querySelector('body');
  if (checkBox) {
    checkBox.addEventListener('change', () => {
      body.style.overflowY = checkBox.checked ? 'hidden' : '';
    })
  }
}

export { initUpdateNavbarOnScroll, initPreventScrollOnNavbar };
